import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MeetingsStatisticsAPI from '../../../api/MeetingsStatisticsAPI';
import { meetingTypeToTranslationKey, meetingTypesArray, MeetingType } from '../../../shared/meetingTypeToTranslationKey';
import BarChart from '../../../components/BarChart/BarChart';
import NoData from '../../../components/NoData/NoData';

type Props = { timeRange: { start: string; end: string } };

function MeetingsTypeDistribution({ timeRange }: Props) {
  const { t } = useTranslation();
  const [labels, setLabels] = useState<string[]>([]);
  const [values, setValues] = useState<number[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await MeetingsStatisticsAPI.getMeetingsTypeDistribution({ startTime: timeRange.start, endTime: timeRange.end });
        const rawLabels = res.data?.labels || [];
        const values = res.data?.values || [];

        const mappedLabels = rawLabels.map((label: string) => {
          if (meetingTypesArray.includes(label as MeetingType)) {
            return t(meetingTypeToTranslationKey(label as any)) || label;
          }
          return label;
        });
        setLabels(mappedLabels);
        setValues(values);
      } catch (e) {
        setLabels([]);
        setValues([]);
      }
    };
    fetchData();
  }, [timeRange.start, timeRange.end, t]);

  if (!labels.length) return <NoData message={t('global.empty_results')} />;

  return (
    <BarChart
      title={t('stats.meetings_type_distribution') || 'Meetings type %'}
      xLabels={labels}
      dataSets={[{
        label: t('stats.meetings') || 'Meetings',
        data: values,
        backgroundColor: ['rgba(16, 185, 129, 0.6)'],
        borderColor: ['rgba(16, 185, 129, 0.6)'],
        borderWidth: 1,
      }]}
    />
  );
}

export default MeetingsTypeDistribution;


